import { css, CSSResult } from 'lit';
import { rem, spacing } from '@thiememeulenhoff/lit-sdk';
import { tagName } from '../../../helpers';

export const tag = tagName('drop-zone');

const styles: Array<CSSResult> = [];

styles.push(css`
  .container {
    display: flex;
    flex-direction: column;
    gap: ${spacing(100)};
  }

  :host([horizontal]) .container {
    align-items: center;
    flex-direction: row;
  }

  .clickable-area {
    position: relative;
  }

  .clickable-area::before {
    background: transparent;
    block-size: ${rem(40)};
    content: '';
    inline-size: ${rem(40)};
    inset-block-start: 50%;
    inset-inline-start: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    z-index: -1;
  }
`);

export const dropZoneStyles = styles;
